import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateTaskOccurrence, type TaskOccurrenceStatus } from "@dashboard/api/task";

interface UpdateTaskOccurrenceStatusVariables {
    id: number;
    status: TaskOccurrenceStatus;
}

export function useUpdateTaskOccurrenceStatus() {
    const queryClient = useQueryClient();

    return useMutation<void, Error, UpdateTaskOccurrenceStatusVariables>({
        mutationFn: async ({ id, status }) => {
            await updateTaskOccurrence(id, { status });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["taskOccurrences"] });
            queryClient.invalidateQueries({ queryKey: ["listsWithTasks"] });
            queryClient.invalidateQueries({ queryKey: ["taskListWithTasks"] });
        },
    });
}
